export enum SocketEvents {
  JOIN = 'join',
  NEW_NOTIFICATION = 'new-notification',
  SYNC_APPOINTMENT = 'sync-appointment',
}
